import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2.5),
    cursor: 'pointer',
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.custom.light,
    },
  },
  headerContent: {
    flex: 1,
    minWidth: 0,
  },
  moduleTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  moduleMeta: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  chevron: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
    marginLeft: theme.spacing(2),
  },
  lessonsList: {},
  lessonRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      gap: theme.spacing(1),
    },
  },
  lessonLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  lessonRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexShrink: 0,
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      width: '100%',
      justifyContent: 'flex-end',
    },
  },
  checkIcon: {
    fontSize: 18,
    color: theme.palette.divider,
    flexShrink: 0,
  },
  checkIconCompleted: {
    color: theme.palette.statusLabel.success.primary,
  },
  lessonIcon: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  lessonTitle: {
    fontSize: 14,
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  completedAt: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  actionButton: {
    fontSize: 12,
    whiteSpace: 'nowrap',
    borderRadius: 6,
    textTransform: 'none',
    padding: theme.spacing(0.5, 1.5),
  },
  actionButtonSuffix: {
    '@media (max-width: 384px)': {
      display: 'none',
    },
  },
}))

export default useStyles
